export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=706c89627758e985cb0f49fdb32e0f3001520c1017&name=pushAdClickData!'